import { useTranslation } from 'react-i18next';

import { ServiceAgreementTermsEnum } from '../../../../api/generated/pm';
import { getAgreementTypeText } from '../../../../components/ServiceAgreement/Common/ServiceAgreementRowHelper';
import CellText from './CellText';

export interface ServiceTypeCellProps {
  agreementTerms: ServiceAgreementTermsEnum;
}

/** Service type cell (PRD D8: shared tier label), shared by all three pages. */
export default function ServiceTypeCell({ agreementTerms }: ServiceTypeCellProps) {
  const { t } = useTranslation();
  return <CellText text={getAgreementTypeText(agreementTerms, t)} />;
}
